import { useSelector } from "react-redux";
import {
  getAppIconColors,
  getPartnerThemeConfig,
} from "../../dataLayer/reducers/webAppThemeConfig";

export const useAppThemeConfig = () => {
  const partnerThemeConfig = useSelector(getPartnerThemeConfig);
  const iconColors = useSelector(getAppIconColors);

  return {
    colorsConfig: partnerThemeConfig.colors,
    partnerConfig: partnerThemeConfig.partnerConfig,
    iconColors,
  };
};
